(function () {
  function initAboutReveal() {
    var items = document.querySelectorAll('.about-reveal');
    if (!items.length) return;

    var observer = new IntersectionObserver(
      function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.18,
        rootMargin: '0px 0px -40px 0px'
      }
    );

    items.forEach(function(item) {
      observer.observe(item);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAboutReveal);
  } else {
    initAboutReveal();
  }

  document.addEventListener('shopify:section:load', initAboutReveal);
})();